
import VClamp from 'vue-clamp'

export default {
  components: { VClamp },
  props: {
    header: { type: Object, required: true },
    pagination: { type: Object, required: true },
    width: { type: Number, default: null },
    dense: { type: Boolean, default: false },
    noInteraction: { type: Boolean, default: false }
  },
  data () {
    return {
      hovered: false
    }
  },
  methods: {
    hover (value) {
      if (this.noInteraction) return
      this._hoverTimeout = setTimeout(() => { this.hovered = true }, 60)
    },
    leave (value) {
      if (this.noInteraction) return
      if (this._hoverTimeout) {
        clearTimeout(this._hoverTimeout)
        delete this._hoverTimeout
      }
      this.hovered = false
    }
  }
}
